export default {"src":"/_next/static/media/0x15eefe5b297136b8712291b632404b66a8ef4d25.6a67c0df.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};